<mat-card class="station-card">
  <div class="station-header">
    <div class="station-details">
      <ng-container *ngIf="selectedStation; else noStationInfo">
        <div class="station-info">
          <h2>{{ selectedStation.name }}</h2>
          <div class="station-meta">
            <span class="call-sign">{{ selectedStation.call_sign }}</span>
            <span class="separator">•</span>
            <span class="dial-position">{{ selectedStation.dial_position }} FM</span>
            <span class="separator">•</span>
            <span class="format">{{ selectedStation.format }}</span>
          </div>
        </div>
      </ng-container>

      <ng-template #noStationInfo>
        <div class="station-info">
          <h2>{{ title }}</h2>
          <p class="station-meta">{{ subtitle }}</p>
        </div>
      </ng-template>
    </div>

    <div class="station-select">
      <mat-form-field appearance="outline" class="station-form-field" subscriptSizing="dynamic">
        <mat-label>Select Station</mat-label>
        <mat-select
          [ngModel]="selectedStation"
          (ngModelChange)="onStationChange($event)"
          [disabled]="loading && stations.length === 0"
          [compareWith]="compareStations">
          <mat-option *ngFor="let station of sortedStations" [value]="station">
            {{ station.call_sign }} - {{ station.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="loading && stations.length === 0" class="station-loading-bar" role="status" aria-live="polite">
        <mat-spinner diameter="22" class="station-loading-spinner"></mat-spinner>
        <span class="station-loading-text">Loading stations…</span>
      </div>
    </div>
  </div>
</mat-card>
